export default {
  articleSearchInputName: 'article search',
  articleSearchInputPlaceholder: 'Search Help Articles',
  articleSearchButton: 'Submit Search',
  kbHeaderResults: '{{resultsCount}} results',
  articleSearchClearButton: 'Clear Search Entry',
};
